// extracted by mini-css-extract-plugin
export default {"circle":"Circle_circle__OR7iu"};